import React from "react";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import textRu from "../locales/ru/ru.json";
import textEn from "../locales/en/en.json";

export default function usePolicyText(lang, interpolation = {}) {
  const text = (lang || i18n.language) === "ru" ? textRu : textEn;
  const { t: tActive } = useTranslation();
  // Явно переданный lang должен «пиннить» и сами строки, а не только выбор
  // JSON для итерации: иначе на RU-локали EN-only ключи (new_policy_*)
  // рендерились сырыми ключами на /privacy-payplus и /conditions-payplus.
  // getFixedT читает из нужного бандла независимо от активного языка.
  const t = lang ? i18n.getFixedT(lang) : tActive;

  const renderTitle = (keyTwoLevel, keyThreeLevel) => {
    if (keyThreeLevel) {
      return (
        <div className="conditions-page__content__title__sub">
          {t(`${keyTwoLevel}.${keyThreeLevel}.title`, interpolation)}
        </div>
      );
    }
    return (
      <div className="conditions-page__content__title">
        {t(`${keyTwoLevel}.title`, interpolation)}
      </div>
    );
  };
  const renderTwoLevelParagraph = (
    keyTwoLevel,
    keyThreeLevel,
    withDash = false
  ) => {
    if (keyThreeLevel) {
      return (
        <div className="conditions-page__content__subtitles conditions-page__content__subtitles">
          {renderTitle(keyTwoLevel, keyThreeLevel)}
          {text[keyTwoLevel][keyThreeLevel]?.text?.map((txt, i) => {
            return (
              <div
                key={i}
                className={`conditions-page__content__subtitles__subtitle
                  conditions-page__content__subtitles__subtitle_three-level`}
              >
                {withDash ? "-" : ""}{" "}
                {t(`${keyTwoLevel}.${keyThreeLevel}.text.${i}.desc`, interpolation) ===
                `${keyTwoLevel}.${keyThreeLevel}.text.${i}.desc`
                  ? ""
                  : t(`${keyTwoLevel}.${keyThreeLevel}.text.${i}.desc`, interpolation)}
              </div>
            );
          })}
        </div>
      );
    }
    return (
      <div className="conditions-page__content">
        {renderTitle(keyTwoLevel)}
        {text[keyTwoLevel]?.text?.map((txt, i) => {
          return (
            <div
              key={i}
              className="conditions-page__content__subtitles__subtitle"
            >
              {t(`${keyTwoLevel}.text.${i}.desc`, interpolation) ===
              `${keyTwoLevel}.text.${i}.desc`
                ? ""
                : t(`${keyTwoLevel}.text.${i}.desc`, interpolation)}
            </div>
          );
        })}
      </div>
    );
  };

  return {
    text,
    t,
    renderTwoLevelParagraph,
    renderTitle,
  };
}
